var UserType;
(function (UserType) {
    UserType["BUYER"] = "buyer";
    UserType["SERVICES_PROVIDER"] = "services_provider";
    UserType["EKHO_INTERNAL"] = "ekho_internal";
    UserType["SERVICE_ACCOUNT"] = "service_account";
})(UserType || (UserType = {}));
var OnboardingState;
(function (OnboardingState) {
    OnboardingState["INVITED"] = "invited";
    OnboardingState["MIGRATING"] = "migrating";
    OnboardingState["NEEDS_PROFILE"] = "needs_profile";
    OnboardingState["NEEDS_EMAIL_VERIFICATION"] = "needs_email_verification";
    OnboardingState["NEEDS_MFA"] = "needs_mfa";
    OnboardingState["COMPLETE"] = "complete";
})(OnboardingState || (OnboardingState = {}));
var MFAPreferredFactorType;
(function (MFAPreferredFactorType) {
    MFAPreferredFactorType["SMS"] = "sms";
    MFAPreferredFactorType["TOTP"] = "totp";
    MFAPreferredFactorType["EMAIL"] = "email";
})(MFAPreferredFactorType || (MFAPreferredFactorType = {}));

export { MFAPreferredFactorType, OnboardingState, UserType };
//# sourceMappingURL=User.js.map
